function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { logger as N } from "../../shared-lib/index.js";
import { getErrorMessage as si } from "./error-utils.js";
import { decodeBrazeActions as uo } from "./string-utils.js";
import { BRAZE_ACTION_URI_REGEX as to, isValidBrazeActionType as co, isValidBrazeActionJson as io } from "./validation-utils.js";
export var BRAZE_ACTIONS = {
  types: {
    io: "container",
    logCustomEvent: "logCustomEvent",
    setEmailNotificationSubscriptionType: "setEmailNotificationSubscriptionType",
    setPushNotificationSubscriptionType: "setPushNotificationSubscriptionType",
    setCustomUserAttribute: "setCustomUserAttribute",
    requestPushPermission: "requestPushPermission",
    addToSubscriptionGroup: "addToSubscriptionGroup",
    removeFromSubscriptionGroup: "removeFromSubscriptionGroup",
    addToCustomAttributeArray: "addToCustomAttributeArray",
    removeFromCustomAttributeArray: "removeFromCustomAttributeArray",
    co: "openLink",
    mo: "openLinkInWebView"
  },
  properties: {
    type: "type",
    eo: "steps",
    so: "args"
  }
};
export var INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES = {
  Qr: "unknownBrazeAction",
  Vr: "noPushPrompt"
};
export var ineligibleBrazeActionURLErrorMessage = function ineligibleBrazeActionURLErrorMessage(t, o) {
  switch (t) {
    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Qr:
      return "".concat(o, " contains an unknown braze action type and will not be displayed.");

    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Vr:
      return "".concat(o, " contains a push prompt braze action, but is not eligible for a push prompt. Ignoring.");

    default:
      return "";
  }
};
export function getDecodedBrazeAction(t) {
  try {
    var o = t.match(to),
        r = o ? o[0].length : null,
        n = r ? t.substring(r) : null;
    if (null == r || r > t.length - 1 || !n) return void N.error("Did not find base64 encoded brazeAction in url to process : ".concat(t));
    var e = uo(n);
    return e ? JSON.parse(e) : void N.error("Failed to decode base64 encoded brazeAction: ".concat(n));
  } catch (o) {
    return void N.error("Failed to process brazeAction URL ".concat(t, " : ").concat(si(o)));
  }
}

function po(t, o) {
  var r = !1;

  if (o) {
    var _iterator = _createForOfIteratorHelper(o),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        if (r = r || t(n), r) return !0;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return !1;
}

export function containsUnknownBrazeAction(t) {
  var o = BRAZE_ACTIONS.properties.type,
      r = BRAZE_ACTIONS.properties.eo;

  try {
    if (null == t) return !0;
    var n = t[o];
    return n === BRAZE_ACTIONS.types.io ? po(containsUnknownBrazeAction, t[r]) : !co(n);
  } catch (t) {
    return !0;
  }
}
export function containsPushPrimerBrazeAction(t) {
  if (!t || !io(t)) return !1;
  var o = BRAZE_ACTIONS.properties.type,
      r = BRAZE_ACTIONS.properties.eo,
      n = t[o];
  return n === BRAZE_ACTIONS.types.io ? po(containsPushPrimerBrazeAction, t[r]) : n === BRAZE_ACTIONS.types.requestPushPermission;
}